import { ChakraFlex as Flex } from "@airhelp/react-ui-components";
import type { SbEditableComponentProps } from "types/storyblok";
import { CardFooter } from "./CardFooter";
import { CardHeader } from "./CardHeader";
import { CardBody } from "./CardBody";
import type { TrustpilotReviewCardProps } from "./TrustpilotReviewCard.d";

export const TrustpilotReviewCard = ({
  reviewText,
  author,
  authorsCountry,
  rating,
  avatarSrc,
  date,
  sbEditable,
}: SbEditableComponentProps<TrustpilotReviewCardProps>) => (
  <Flex flexDir="column" {...sbEditable}>
    <CardHeader rating={rating} date={date} />
    <CardBody reviewText={reviewText} />
    {author && <CardFooter avatarSrc={avatarSrc} author={author} authorsCountry={authorsCountry} mt={12} />}
  </Flex>
);
